<div
  *ngIf="channelSummary.type === 'field' && !showMeasureNamesPill"
  class="field"
  attr.data-test="{{ channelSummary.channel }}-field"
  [class.mark-dragging]="isDragging"
  [dndDraggable]="channelSummary.field"
  [dndDisableDropIf]="disableDrop"
  dndEffectAllowed="move"
  (dndStart)="onDragStart($event)"
  (dndEnd)="onDragEnd($event)"
>
  <div
    class="field-dropzone"
    dndDropzone
    [dndDisableDropIf]="disableDrop"
    [dndAllowExternal]="true"
    (dndDrop)="onFieldDrop($event)"
  ></div>
  <mode-encoding-field-all
    *ngIf="!series"
    (update)="onFieldUpdated($event)"
    (remove)="onRemoveField({ $field: fieldIds })"
    (removeSort)="onRemoveSort($event)"
    (splitLegend)="onSetLegendSplit($event)"
    (getBinSize)="onGetBinSize($event)"
    [encoding]="encoding"
    [field]="channelSummary.field"
    [fieldFormatMap]="fieldFormatMap"
    [binSizeToFieldMap]="binSizeToFieldMap"
    [format]="format"
    [model]="model"
    [view]="view"
    [viewName]="queryToken"
    [vizToken]="vizToken"
    [allowScalars]="allowScalars"
    [allowAggregates]="allowAggregates"
    [allowDiscrete]="allowDiscrete"
    [allowContinuous]="allowContinuous"
    [allowBinned]="allowBinned"
    [chartType]="chartType"
    [showColorSettings]="showColorSettings"
    [canLegendBeSplit]="canLegendBeSplit"
    [hasSplitLegend]="hasSplitLegend"
  ></mode-encoding-field-all>
  <mode-encoding-field-single
    *ngIf="series"
    (update)="onFieldUpdated($event)"
    (remove)="onRemoveField($event)"
    (removeSort)="onRemoveSort($event)"
    (isValidField)="onIsValidField($event)"
    (splitLegend)="onSetLegendSplit($event)"
    (getBinSize)="onGetBinSize($event)"
    [encoding]="encoding"
    [field]="channelSummary.field"
    [fieldFormatMap]="fieldFormatMap"
    [binSizeToFieldMap]="binSizeToFieldMap"
    [format]="format"
    [model]="model"
    [view]="view"
    [viewName]="queryToken"
    [vizToken]="vizToken"
    [chartType]="chartType"
    [allowScalars]="allowScalars"
    [allowAggregates]="allowAggregates"
    [allowDiscrete]="allowDiscrete"
    [allowContinuous]="allowContinuous"
    [allowBinned]="allowBinned"
    [showColorSettings]="showColorSettings"
    [canLegendBeSplit]="canLegendBeSplit"
    [hasSplitLegend]="hasSplitLegend"
  ></mode-encoding-field-single>
</div>

<div *ngIf="channelSummary.type === 'multiple'" class="field" [class.mark-dragging]="isDragging" attr.data-test="multiple-zone">
  <div
    class="field-dropzone"
    dndDropzone
    [dndDisableDropIf]="disableDrop"
    [dndAllowExternal]="true"
    (dndDrop)="onFieldDrop($event)"
  ></div>
  <mode-encoding-field-multiple
    [isValidMultiple]="channelSummary.isValid"
    (remove)="onRemoveMultiple()"
    capraTooltip
    [tooltipContent]="multipleTooltip"
    [tooltipInteractive]="false"
    [tooltipDelay]="[750, 0]"
    tooltipPlacement="bottom"
  >
  </mode-encoding-field-multiple>
</div>

<mode-encoding-field-measure-names
  *ngIf="showMeasureNamesPill"
  attr.data-test="measure-names-zone"
  [dragInfo]="dragInfo"
  [field]="channelSummary.field"
  [encoding]="encoding"
  [chartService]="chartService"
  [chartType]="chartType"
  [series]="series"
  [allowContinuous]="allowContinuous"
  (fieldDropped)="onDropOnMeasureNames()"
></mode-encoding-field-measure-names>

<mode-typeahead-attrs-list
  *ngIf="channelSummary.type === 'empty'"
  attr.data-test="{{ channelSummary.channel }}-zone"
  class="empty-drop-zone--typeahead"
  [class.drag-highlight]="isDragging"
  data-test="marks-dropzone"
  dndDropzone
  placeholderText="Add a field to {{ channelSummary.channel | titlecase }}"
  [view]="view"
  [chartType]="chartType"
  [dndDisableDropIf]="disableDrop"
  (attrSelected)="onTypeAheadSelection($event)"
  (dndDrop)="onEmptyFieldDrop($event)"
></mode-typeahead-attrs-list>
